import React from "react";
import { useHistory} from "react-router-dom";
import { toast } from "react-toastify";
import "../components/style.scss"
const UpdateProduct = () => {
    let history = useHistory();
    const handleSubmit = async (e) => {
    history.push("/shops/Dash");
    toast.warn("Preview doesn't support Product Updation")
    };
    const mainHeader = {width: "100%",
    maxWidth: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"};

    const forms = {
        width: "464px",
        height: "694px",
        padding: "62px 48px",
        border: "1px solid #c2c2c2",
        borderRadius: "15px",
        textAlign: "start",
        fontFamily: "'Noto Sans', sans-serif",
        fontSize: "14px",
        marginBottom: "17px",
        color: "#212121"
    };

    const btnOrange =  {
        backgroundColor: "#f54336",
        width: "100%",
        color: "#fff",
        borderRadius: "30px",
        marginTop: "10px",
        marginBottom: "10px",
        fontSize:"13px"
    };

    const h2 = {
        marginBottom: "17px ",
        color: "#212121"
    };
    const formGroup =  {
        marginBottom:"10px"
    };

    const formControl = {
        paddingTop: "30px",
        paddingLeft: "0",
        paddingBottom: "30px",
        outline: "none",
        border: "none",
        borderBottom: "1px solid #e0e2e6",
        borderRadius: "0px",
        marginTop: "10px",
        width: "100%", 
        '&::focus': {
             borderBottom: "1px solid #f54336",
             outline: "none",
             boxShadow: "none"
        }
    };
    return(
        <div className="update">
            <header id="main-header" style={mainHeader}>
                <div  className="row row-col-4" style={{marginTop:"3%"}}>
                <div className="update-row">
                    <img src={process.env.PUBLIC_URL +"/uploads/DSCN2357-1606917129648.jpg"} alt="existing"/>
                        <form>
                            <div className="custom-file mb-4">
                                <input type="file" className="custom-file-input" id="customFile"/>
                                    <label className="custom-file-label" htmlFor="customFile">Choose File:</label>
                            </div>
                        </form>
                </div>
                <div className="update-row">
                <div className="form" style={forms}>
                    <div className="form-group" style={formGroup}>
                        <label htmlFor="name"><h2 style={h2}>Name</h2></label>
                        <input id="name" className="form-control" type="text" placeholder="SHAWARMA" style={formControl}/>
                    </div>
                    <div className="form-group" style={formGroup}>
                        <label htmlFor="Detail">Detail</label>
                        <input id="detail" className="form-control" type="text" placeholder="Full plate" style={formControl}/>
                    </div>
                    <div className="form-group" style={formGroup}>
                        <label htmlFor="producttime">Product Time (if it takes time to product be ready)</label>
                        <input id="time" className="form-control" type="time" placeholder="00:10:00" style={formControl}/>
                    </div>
                    <div className="form-group" style={formGroup}>
                        <label htmlFor="productcount">Product Count (if the product is limited)</label>
                        <input id="count" className="form-control" type="number" placeholder="" style={formControl}/>
                    </div>
                    <div className="form-group" style={formGroup}>
                        <label htmlFor="price">Price</label>
                        <input id="price" className="form-control" type="number" placeholder="200" style={formControl}/>
                    </div>
                    <div className="form-group" style={formGroup}>
                        <label htmlFor="Live">Live or Sold Out</label>
                        <select className="btn btn-info" placeholder="Live" type="boolean">
                            <option></option><option>Available</option><option >Sold Out</option>
                        </select>
                    </div>
                    <button className="btn btn-orange" style={btnOrange} onClick={handleSubmit}>Submit</button>
                </div></div></div>
            </header>  
        </div>
    );
};
export default UpdateProduct;